import React from 'react';
import {
  createStyles,
  Switch,
  SwitchClassKey,
  SwitchProps,
  Theme,
  withStyles,
} from '@material-ui/core';
import colors from '../../../../../themes/main-colors';

interface Styles extends Partial<Record<SwitchClassKey, string>> {
  focusVisible?: string;
}
interface Props extends SwitchProps {
  classes: Styles;
}

export const ToggleSwitch = withStyles((theme: Theme) =>
  createStyles({
    root: {
      width: 52,
      height: 32,
      padding: 0,
      margin: theme.spacing(1),
    },
    switchBase: {
      padding: 2,
      left: 0,
      '&$checked': {
        transform: 'translateX(20px)',
        color: colors.white,
        '& + $track': {
          backgroundColor: colors.sparkBlue,
          opacity: 1,
          border: 'none',
        },
      },
      '&$focusVisible $thumb': {
        color: colors.sparkBlue,
      },
    },
    thumb: {
      width: 28,
      height: 28,
    },
    track: {
      borderRadius: 32 / 2,
      backgroundColor: theme.palette.grey[600],
      opacity: 1,
      transition: theme.transitions.create(['background-color', 'border']),
    },
    checked: {},
    focusVisible: {},
  }),
)(({ classes, ...props }: Props) => {
  return (
    <Switch
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
      }}
      {...props}
    />
  );
});
